import Link from '@jetbrains/ring-ui/components/link/link'
import React, {memo} from 'react'

import Details from '../../../../Details/Details'
import SettingsBlock from '../../../../SettingsBlock/SettingsBlock'
import SidebarSelect from '../../SidebarSelect/SidebarSelect'

import {linkCloudImageHardwareDoc} from './JobAgentRequirements.consts'
import useJobAgentRequirements from './JobAgentRequirements.hooks'
import type {JobAgentRequirementsProps} from './JobAgentRequirements.types'

import styles from './JobAgentRequirements.css'

function JobAgentRequirements({jobId}: JobAgentRequirementsProps) {
  const {agents, selectedCloudImage, handlerColudImageSelect} = useJobAgentRequirements(jobId)

  return (
    <SettingsBlock
      id={'agent'}
      title={'Run on'}
      collapsedNote={
        selectedCloudImage && `${selectedCloudImage.label}, ${selectedCloudImage.details}`
      }
      collapsible
    >
      <SidebarSelect
        data={agents}
        popupClassName={styles.selectPopup}
        containerClassName={styles.selectContainer}
        selected={selectedCloudImage}
        selectedLabel={selectedCloudImage?.details}
        onSelect={handlerColudImageSelect}
      />
      <Details className={styles.info}>
        {
          'These agents are maintained by JetBrains and ship all software and tools required for the majority of building tasks. If you need any extra tools, you can run install commands via the CLI Runner.'
        }
        <Link
          className={styles.hardwareDocLink}
          target="_blank"
          href={linkCloudImageHardwareDoc}
          rel="noreferrer"
        >
          {'Show installed software'}
        </Link>
      </Details>
    </SettingsBlock>
  )
}

export default memo(JobAgentRequirements)
